import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper";

import { Container, Text } from "components";

import ctl from "@netlify/classnames-template-literals";

const Clients = () => {
  return (
    <div className={clientsWrapperStyle} id="partners">
      <Container>
        <Text
          value="Some of the amazing businesses building with Parkway"
          variant="h3"
          color="secondary-1200"
        />

        <div className={swiperWrapperStyle}>
          <Swiper
            className=" "
            loop={true}
            spaceBetween={24}
            slidesPerView={2.7}
            breakpoints={breakpoints}
            grabCursor={true}
            modules={[Autoplay]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
          >
            {slides.map((slide, index) => {
              return (
                <SwiperSlide key={`client_logo_${index}`}>{slide}</SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </Container>
    </div>
  );
};

const breakpoints = {
  640: {
    slidesPerView: 3.4,
  },
};

const logoImageProp = {
  height: 55,
};
const slides = [
  <StaticImage
    src="../../assets/images/client-logos/Payzone.png"
    alt="Payzone"
    {...logoImageProp}
  />,
  <StaticImage
    src="../../assets/images/client-logos/Redcloud.png"
    alt="Redcloud"
    {...logoImageProp}
  />,
  <StaticImage
    src="../../assets/images/client-logos/Schoolable.png"
    alt="Schoolable"
    {...logoImageProp}
  />,
  <StaticImage
    src="../../assets/images/client-logos/Shutters.png"
    alt="Shutters"
    {...logoImageProp}
  />,
  <StaticImage
    src="../../assets/images/client-logos/Little.png"
    alt="Little"
    {...logoImageProp}
  />,
];

const clientsWrapperStyle = ctl(`
text-center
md:py-[130px]
py-[64px]
`);

const swiperWrapperStyle = ctl(`
border
border-secondary-600
md:py-[56px]
py-[24px]
md:mt-[60px]
mt-[32px]
`);

export { Clients };
